import { useParams, Link } from 'react-router-dom'
import { ChevronLeft, Edit, Download, Trash2 } from 'lucide-react'

function AlbumDetailPage() {
  const { id } = useParams<{ id: string }>()

  return (
    <div>
      {/* Header */}
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-4">
          <Link
            to="/albums"
            className="flex items-center gap-1 text-muted-foreground hover:text-foreground"
          >
            <ChevronLeft size={20} />
            Albums
          </Link>
          <h1 className="text-2xl font-bold">Album {id}</h1>
        </div>

        <div className="flex items-center gap-2">
          <button className="flex items-center gap-2 px-3 py-1.5 hover:bg-secondary rounded-md text-sm">
            <Edit size={16} />
            Edit
          </button>
          <button className="flex items-center gap-2 px-3 py-1.5 bg-primary hover:bg-primary/90 text-primary-foreground rounded-md text-sm">
            <Download size={16} />
            Export
          </button>
          <button className="flex items-center gap-2 px-3 py-1.5 hover:bg-destructive/20 text-destructive rounded-md text-sm">
            <Trash2 size={16} />
            Delete
          </button>
        </div>
      </div>

      {/* Info */}
      <div className="text-sm text-muted-foreground mb-6">
        0 photos | Created: -- | Last modified: --
      </div>

      {/* Empty State */}
      <div className="flex items-center justify-center h-64 border border-dashed border-border rounded-lg">
        <div className="text-center text-muted-foreground">
          <p className="mb-2">No photos in this album</p>
          <p className="text-sm">Select photos from the Library and add them here</p>
        </div>
      </div>
    </div>
  )
}

export default AlbumDetailPage
